// Lib
import { NativeTypes } from 'react-dnd-html5-backend';

// Constants
import { FILE_TYPE } from '../../../../common/files/fileConstants';
import { CARD_TYPE } from '../../../../common/cards/cardConstants';
import { LINK_TYPE } from '../../../../common/links/linkConstants';

export default (elementPredicates) =>
    ({ monitor }) => {
        const itemType = monitor.getItemType();

        // Don't fail for files, text or urls unless they're aren't allowed
        if (itemType === NativeTypes.FILE) return !elementPredicates.some((predicate) => predicate(FILE_TYPE));
        if (itemType === NativeTypes.TEXT) return !elementPredicates.some((predicate) => predicate(CARD_TYPE));
        if (itemType === NativeTypes.URL) return !elementPredicates.some((predicate) => predicate(LINK_TYPE));

        const item = monitor.getItem();
        return (
            item.element &&
            item.draggedElements.filter((element) => !elementPredicates.some((predicate) => predicate(element)))
                .length > 0
        );
    };
